import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Search, ArrowUpRight } from "lucide-react";
import { BIST_QUICK } from "@/lib/quickSymbols";

// Larger list from bist_symbols on frontend side — use BIST_QUICK (top 50) + extended fetched on mount
export default function GlobalSearch({ open, onClose }) {
  const [q, setQ] = useState("");
  const [symbols, setSymbols] = useState(BIST_QUICK);
  const nav = useNavigate();

  // Load extended list once
  useEffect(() => {
    if (!open) return;
    (async () => {
      try {
        const url = `${process.env.REACT_APP_BACKEND_URL}/api/symbols?universe=bist_all`;
        const r = await fetch(url);
        const d = await r.json();
        if (d?.symbols) setSymbols(d.symbols.map((s) => s.symbol));
      } catch {}
    })();
  }, [open]);

  const results = useMemo(() => {
    const term = q.trim().toUpperCase();
    if (!term) return symbols.slice(0, 12);
    return symbols.filter((s) => s.startsWith(term)).slice(0, 30);
  }, [q, symbols]);

  const pick = (sym) => { onClose(); nav(`/stock/${sym}`); };

  if (!open) return null;

  return (
    <div
      data-testid="global-search-modal"
      className="fixed inset-0 z-[100] bg-black/60 backdrop-blur-sm flex items-start justify-center pt-24 px-4"
      onClick={onClose}
    >
      <div
        className="w-full max-w-lg bg-bg-panel border border-bg-border rounded-xl shadow-2xl overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center gap-2 px-4 py-3 border-b border-bg-border">
          <Search size={16} className="text-text-secondary" />
          <input
            data-testid="global-search-input"
            autoFocus
            value={q}
            onChange={(e) => setQ(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && results[0]) pick(results[0]);
              if (e.key === "Escape") onClose();
            }}
            placeholder="Hisse ara... (örn: AKBNK)"
            className="flex-1 bg-transparent text-text-primary text-sm outline-none placeholder:text-text-secondary/60 font-mono uppercase tracking-wider"
          />
          <span className="text-[10px] text-text-secondary bg-bg-base border border-bg-border px-2 py-0.5 rounded">ESC</span>
        </div>
        <div className="max-h-80 overflow-y-auto py-1">
          {results.length === 0 ? (
            <div className="p-6 text-center text-sm text-text-secondary">Sonuç yok</div>
          ) : results.map((s) => (
            <button
              key={s}
              data-testid={`global-search-item-${s}`}
              onClick={() => pick(s)}
              className="w-full flex items-center justify-between px-4 py-2.5 hover:bg-bg-hover transition-colors group"
            >
              <span className="text-text-primary font-mono font-bold tracking-wider text-sm">{s}</span>
              <ArrowUpRight size={14} className="text-text-secondary opacity-0 group-hover:opacity-100 transition-opacity" />
            </button>
          ))}
        </div>
        <div className="px-4 py-2 border-t border-bg-border text-[10px] text-text-secondary flex items-center justify-between">
          <span>↵ Aç · ↑↓ Gezin</span>
          <span>Ctrl/⌘ + K ile açılır</span>
        </div>
      </div>
    </div>
  );
}
